<template>
  <div class="wallet-form__amount-group">
    <div class="wallet-form__amount-row">
      <slot />
      <aside
        class="wallet-form__usdt-inline"
        :class="{ 'wallet-form__usdt-inline--empty': krwAmount <= 0 && !loading }"
      >
        <span class="wallet-form__usdt-inline-label">≈</span>
        <span class="wallet-form__usdt-inline-body">
          <template v-if="krwAmount > 0">
            <template v-if="loading && usdtAmount == null">
              <span class="wallet-form__usdt-inline-value">…</span>
            </template>
            <template v-else-if="usdtAmount != null">
              <strong
                class="wallet-form__usdt-inline-value"
                :title="formattedUsdtFull"
              >{{ formattedUsdt }}</strong>
            </template>
            <template v-else-if="error">
              <span class="wallet-form__usdt-inline-value wallet-form__usdt-inline-value--error">—</span>
            </template>
          </template>
          <template v-else>
            <span class="wallet-form__usdt-inline-value">—</span>
          </template>
        </span>
        <span class="wallet-form__usdt-inline-unit">USDT</span>
      </aside>
    </div>
    <p v-if="rate" class="wallet-form__usdt-rate">
      {{ $t('wallet.rateLabel', { rate: formattedRate }) }}
      <span class="wallet-form__usdt-rate-hint">{{ $t('wallet.rateLive') }}</span>
    </p>
    <p v-else-if="error && krwAmount > 0" class="wallet-form__usdt-rate wallet-form__usdt-rate--error">
      {{ error }}
    </p>
  </div>
</template>

<script>
import { subscribeBithumbUsdtRate } from '@/services/bithumbRate'
import { convertKrwToUsdt, formatUsdtAmount } from '@/utils/format'

export default {
  name: 'WalletUsdtQuote',
  props: {
    krwAmount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      rate: null,
      loading: false,
      error: ''
    }
  },
  computed: {
    usdtAmount () {
      return convertKrwToUsdt(this.krwAmount, this.rate)
    },
    formattedUsdt () {
      if (this.usdtAmount == null) return ''
      return formatUsdtAmount(this.usdtAmount, { maxDecimals: 2, minDecimals: 2 })
    },
    formattedUsdtFull () {
      if (this.usdtAmount == null) return ''
      return formatUsdtAmount(this.usdtAmount, { maxDecimals: 4, minDecimals: 2 })
    },
    formattedRate () {
      if (!this.rate) return ''
      return this.formatCurrency(this.rate)
    }
  },
  mounted () {
    this._unsubscribe = subscribeBithumbUsdtRate((state) => {
      this.rate = state.rate
      this.loading = state.loading
      this.error = state.error
    })
  },
  beforeDestroy () {
    if (this._unsubscribe) this._unsubscribe()
  }
}
</script>
